import { getCurrentInstance, onUnmounted } from 'vue'

export function createEventBus() {
  const listeners = new Map()
  const bus = {
    $on(event, callback) {
      if (Array.isArray(event)) {
        event.forEach(name => bus.$on(name, callback))
        return bus
      }
      const callbacks = listeners.get(event) || []
      callbacks.push(callback)
      listeners.set(event, callbacks)
      if (getCurrentInstance()) onUnmounted(() => bus.$off(event, callback))
      return bus
    },
    $once(event, callback) {
      const once = (...args) => {
        bus.$off(event, once)
        callback(...args)
      }
      once.original = callback
      return bus.$on(event, once)
    },
    $off(event, callback) {
      if (event === undefined) listeners.clear()
      else if (Array.isArray(event)) event.forEach(name => bus.$off(name, callback))
      else if (!callback) listeners.delete(event)
      else {
        const callbacks = listeners.get(event) || []
        const index = callbacks.map(listener => listener === callback || listener.original === callback).lastIndexOf(true)
        if (index !== -1) callbacks.splice(index, 1)
        if (!callbacks.length) listeners.delete(event)
      }
      return bus
    },
    $emit(event, ...args) {
      const callbacks = listeners.get(event) || []
      callbacks.slice().forEach(callback => callback(...args))
      return bus
    }
  }
  return bus
}
